var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{staticClass:"export-button",on:{"click":function($event){_vm.emitClick ? _vm.$emit('click') : _vm.exportAndDownload()}}},[_c('b-icon',{directives:[{name:"page-color",rawName:"v-page-color"}],attrs:{"icon":"download","font-scale":"1.5"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }